import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Container } from "simplydo/react/ui/container";
import { Grid, GridColumn } from "simplydo/react/ui/grid";
import { H1, H2, Subheader } from "simplydo/react/ui/header";

import { useAppSelector } from "store";
import util from "utils/utils";

const NotFound = () => {
  const user = useAppSelector((state) => state.user);
  const { t } = useTranslation();

  return (
    <Container style={{ marginTop: 40 }}>
      <Grid mobile={1} columns={16}>
        <GridColumn span={16} computer={8}>
          <H1>
            Page not found
            <Subheader>
              Sorry, the page you have requested could not be found. If you have
              arrived here by following a link from elsewhere on
              {util.appName()} then please let us know by emailing{" "}
              <a href="mailto:support@simplydo.co.uk">support@simplydo.co.uk</a>
              .
            </Subheader>
          </H1>
        </GridColumn>
        <GridColumn span={16} computer={1} />
        <GridColumn span={16} computer={6}>
          <H2>{t("home.quickLinks")}</H2>
          <p>
            <Link className="with-border" to="/challenges">
              {t("generic.challenges")}
            </Link>
          </p>
          <p>
            <Link className="with-border" to="/ideas">
              {t("generic.ideas")}
            </Link>
          </p>
          {util.hasPermission(
            user,
            "org.viewDashboard",
            user?.ownerOrganisation?._id,
          ) && (
            <p>
              <Link to="/admin" className="with-border">
                {t("generic.admin")}
              </Link>
            </p>
          )}
        </GridColumn>
      </Grid>
    </Container>
  );
};

export default NotFound;
